(function () {
  'use strict';

  var STORAGE_KEY = 'jru_nudge_shown';
  var TIMER_DELAY = 90000; // 90 seconds
  var VIEW_THRESHOLD = 2;  // 2nd product view triggers

  // --- Bail early if already shown this session ---
  if (sessionStorage.getItem(STORAGE_KEY)) return;

  var bar = document.getElementById('jru-nudge-bar');
  if (!bar) return;

  var timer = null;
  var nudgeFired = false;

  // --- Show the bar ---
  function showNudge() {
    if (nudgeFired) return;
    nudgeFired = true;
    clearTimeout(timer);
    sessionStorage.setItem(STORAGE_KEY, '1');
    bar.style.display = '';
    // Force reflow before adding class so transition fires
    bar.getBoundingClientRect();
    bar.classList.add('jru-nudge--visible');
  }

  // --- Dismiss handler (called by inline onclick) ---
  window.__jruDismissNudge = function () {
    bar.classList.remove('jru-nudge--visible');
    bar.addEventListener('transitionend', function () {
      bar.style.display = 'none';
    }, { once: true });
  };

  // --- Trigger 1: 90 second timer ---
  timer = setTimeout(showNudge, TIMER_DELAY);

  // --- Trigger 2: 2nd product view in session ---
  var viewKey = 'jru_pdp_views';
  var views = parseInt(sessionStorage.getItem(viewKey) || '0', 10) + 1;
  sessionStorage.setItem(viewKey, views);

  if (views >= VIEW_THRESHOLD) {
    showNudge();
  }

})();
